import Consts from 'Framework/Consts';
import { HttpDeleteService, IHttpDeleteServiceProps } from 'Shared/HttpServices/Services/HttpDeleteService';
import { HttpGetService, IHttpGetServiceProps } from 'Shared/HttpServices/Services/HttpGetService';
import { HttpPostService, IHttpPostServiceProps } from 'Shared/HttpServices/Services/HttpPostService';
import { HttpPutService } from 'Shared/HttpServices/Services/HttpPutService';
import { createAxiosHttpConfig } from 'Shared/HttpServices/Utils/utils';

const BasicInfoHttpConfig = createAxiosHttpConfig({ baseURL: Consts.env.REACT_APP_BASIC_INFO_APP_BASE_URL });
export const BasicInfoHttpGetService = async (props: IHttpGetServiceProps) =>
  HttpGetService({
    API: BasicInfoHttpConfig,
    url: props.url,
    responseType: props.responseType,
    onResult: props.onResult,
    onError: props.onError,
    isFile: props.isFile,
    params: props.params,
  });

export const BasicInfoHttpPostService = async (props: IHttpPostServiceProps) =>
  HttpPostService({
    API: BasicInfoHttpConfig,
    url: props.url,
    body: props.body,
    onResult: props.onResult,
    onError: props.onError,
  });

export const BasicInfoHttpDeleteService = async (props: IHttpDeleteServiceProps) =>
  HttpDeleteService({
    API: BasicInfoHttpConfig,
    url: props.url,
    body: props.body,
    fromQuery: props.fromQuery,
    onResult: props.onResult,
    onError: props.onError,
  });

export const BasicInfoHttpPutService = async (props: IHttpPostServiceProps) =>
  HttpPutService({
    API: BasicInfoHttpConfig,
    url: props.url,
    body: props.body,
    onResult: props.onResult,
    onError: props.onError,
  });
